// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: '74df65c7-cd74-46ca-8007-67acbf9f0b1e',
      type: 'Container',
      name: 'root',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        dynamicValues: {
          y: 'height * -0.5'
        }
      }
    },
    {
      id: 'c16d4f18-2991-4730-82ec-b112d464fd66',
      type: 'Sprite',
      name: 'bg',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0.7,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Wood_Background',
      parent: '74df65c7-cd74-46ca-8007-67acbf9f0b1e',
      data: {
        dynamicValues: {
          width: 'width',
          height: 'height'
        }
      }
    },
    {
      id: '122b098b-8ceb-482e-8273-61ccbcca945e',
      type: 'Container',
      name: 'contentContainer',
      className: '',
      x: 0,
      y: 640,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '74df65c7-cd74-46ca-8007-67acbf9f0b1e'
    },
    {
      id: 'd6576665-25fc-469e-83c4-bacf8ebd38a6',
      type: 'Sprite',
      name: 'rays',
      className: 'rotate_SPL',
      x: 0,
      y: -127,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16764181,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e'
    },
    {
      id: 'eaff3f14-01df-4fc5-a699-f6ff84c06c10',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -130,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.604348,
        y: 2.573913
      },
      angle: 0,
      alpha: 0.7,
      visible: true,
      tint: 16764181,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e'
    },
    {
      id: '1035a9cb-2e57-4b6c-a148-82b443a2b176',
      type: 'Text',
      name: 'header',
      className: 'colorTags_SPL',
      x: 0,
      y: -449,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Locked Stacks<br>$Unlocked!$',
      localize: false,
      maxWidth: 660,
      maxHeight: 300,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 70,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e',
      data: {
        colorTags: {
          $: '#FFCD15'
        }
      }
    },
    {
      id: 'c37c9266-dca6-4014-9bed-6a5efd288543',
      type: 'Text',
      name: 'description',
      className: 'colorTags_SPL',
      x: 0,
      y: 276,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Clear any tiles and $break the Locks!$',
      localize: false,
      maxWidth: 630,
      maxHeight: 230,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 630,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e',
      data: {
        colorTags: {
          $: '#FFCD15'
        }
      }
    },
    {
      id: 'cbd47c37-9890-4986-ad38-9e7e9fe555dd',
      type: 'Sprite',
      name: 'tutorialBg',
      className: '',
      x: 0,
      y: -88,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 0.953947
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Small_Pop_Up_Background',
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e'
    },
    {
      id: '8a15dc2c-5b57-4269-b159-5ac2ca03d087',
      type: 'Container',
      name: 'tutorialSlot',
      className: '',
      x: 0,
      y: -300,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e'
    },
    {
      id: '3069e91d-ba98-49a0-87e7-65a50c469f30',
      type: 'Container',
      name: 'particleSlot',
      className: '',
      x: 0,
      y: -134,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e'
    },
    {
      id: '19767c69-9330-4c2d-b907-92752879b4f8',
      type: 'Sprite',
      name: 'icon',
      className: '',
      x: 0,
      y: -130,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e'
    },
    {
      id: 'e8ec1faa-2bd4-494c-b2f6-38235b63ef8d',
      type: 'Container',
      name: 'actionButton',
      className: '',
      x: 0,
      y: 482,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e'
    },
    {
      id: 'afc836ec-c919-4da3-a4c3-026583d4bac4',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1.03,
        y: 1.11
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'e8ec1faa-2bd4-494c-b2f6-38235b63ef8d',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '6fe9984d-a134-439d-8269-09e9b7b636a6',
      type: 'Text',
      name: 'buttonText',
      className: '',
      x: 0,
      y: -7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Play',
      localize: true,
      maxWidth: 414,
      maxHeight: 154,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 58,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#1F5316',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'e8ec1faa-2bd4-494c-b2f6-38235b63ef8d',
      stateByName: {
        tutorial: {
          text: 'Next'
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'tutorial'
  ],
  animations: [
    {
      id: '5e52609c-1af0-4d72-9ea6-e5b623d0e499',
      name: 'ShowTutorial',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: 'e23112f9-be03-4d95-804f-1eb6aa15bb82',
          type: 'Tween',
          name: 'setButtonAlpha_0',
          duration: 300,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'actionButton',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '754a167d-9351-4735-93bd-b7e8e2fbb32f',
          type: 'Tween',
          name: 'setIconAlpha_0',
          duration: 299,
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'icon',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '221e32f1-ebfe-47d9-9134-f901e5dc6bf0',
          type: 'Setter',
          name: 'ANIMEVENT_showTutorial',
          track: 3,
          target: {},
          startAt: 300,
          sourceName: 'root',
          disabled: false
        },
        {
          id: 'ef4583ce-c0a3-417e-a6b6-7d023ec92585',
          type: 'Tween',
          name: 'setParticlesAlpha_0',
          duration: 300,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 314,
          sourceName: 'particleSlot',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'f6d26d5d-3ab6-45e5-9698-4d6f266d46cb',
          type: 'Tween',
          name: 'setRaysAlpha_0',
          duration: 300,
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 314,
          sourceName: 'rays',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'b3327e89-3d24-4cb2-8073-f4b97ec96dd6',
          type: 'Tween',
          name: 'setTutorialBgAlpha_0',
          duration: 300,
          track: 4,
          target: {
            alpha: 1
          },
          startAt: 315,
          sourceName: 'tutorialBg',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '454eea58-2339-40ee-bb41-23f250bb523d',
          type: 'Tween',
          name: 'setTutorialAlpha_0',
          duration: 299,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 317,
          sourceName: 'tutorialSlot',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'a8b25c18-b86c-4faa-9c7a-82bd2e5e4544',
          type: 'Tween',
          name: 'setButtonAlpha_1',
          duration: 300,
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 340,
          sourceName: 'actionButton',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class BlockerIntroductionPopupLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  bg!: Sprite & { data: typeof raw['list'][1]['data'] };
  contentContainer!: Container;
  rays!: Sprite;
  header!: Text & { data: typeof raw['list'][5]['data'] };
  description!: Text & { data: typeof raw['list'][6]['data'] };
  tutorialBg!: Sprite;
  tutorialSlot!: Container;
  particleSlot!: Container;
  icon!: Sprite;
  actionButton!: Container;
  buttonText!: Text;
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][0]['data'] } | Sprite & { data: typeof raw['list'][1]['data'] })[];
  rotate_SPL!: (Sprite)[];
  colorTags_SPL!: (Text & { data: typeof raw['list'][5]['data'] } | Text & { data: typeof raw['list'][6]['data'] })[];
  StateName!: 'tutorial';

  constructor() {
    populate(this, raw);
  }
}

export abstract class ShowTutorial {
  Layout: {
    actionButton: object;
    icon: object;
    root: object;
    particleSlot: object;
    rays: object;
    tutorialBg: object;
    tutorialSlot: object;
  };

  BlockTypeByName: {
    setButtonAlpha_0: object;
    setIconAlpha_0: object;
    ANIMEVENT_showTutorial: object;
    setParticlesAlpha_0: object;
    setRaysAlpha_0: object;
    setTutorialBgAlpha_0: object;
    setTutorialAlpha_0: object;
    setButtonAlpha_1: object;
  };

  flowData = raw.animations[0];
}
